import { useStaticQuery, graphql } from 'gatsby';

export const useNavigation = () => {
	const { products, partners, supplierEarlyPayment } = useStaticQuery(
		graphql`
			query Navigation {
				products: allDatoCmsWhatWeDoNavLink(
					sort: { position: ASC }
					filter: {
						isVisible: { eq: true }
						id: { ne: "DatoCmsWhatWeDoNavLink-48368404" }
					}
				) {
					nodes {
						title
						tagline
						iconName
						link
					}
				}
			}
		`
	);

	return {
		products: products.nodes,
	};
};
